const packageJson = require('../../package.json');

module.exports = {
    footerText: process.env.REACT_APP_FOOTER_TEXT,
    appVersion: packageJson.version,
    debounceSearchFilterDelay: 500, //delay in ms
    isDevelopment: process.env.REACT_APP_NODE_ENV === 'development',
};
